export default __webpack_public_path__ + "static/media/male-fat.e59e8b7c.jpg";